import { ReleaseNoteByod } from '@src/main/modules/parameters/domain/release-notes-byod/release-note-byod.interface';
import { createReleaseNoteByodHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/ReleaseNoteByodHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useDeleteReleaseNoteByod = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createReleaseNoteByodHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (id: string) => {
      if (!repository) throw new Error('Repository not initialized');
      await repository.delete(id);
      return id;
    },
    onSuccess: (deletedId) => {
      queryClient.invalidateQueries({ queryKey: ['release-notes-byod'] });
      queryClient.setQueryData<ReleaseNoteByod[]>(
        ['release-notes-byod'],
        (old) => old?.filter((releaseNote) => releaseNote.releaseNoteByodId !== deletedId) ?? [],
      );
    },
  });
};
